<template>
  <div id="app-footer">
    Copyright &copy; 2019-2020
    <a style="color: #ff8a00;" href="https://space.bilibili.com/35723238" target="_blank" rel="noopener noreferrer">只剩一瓶辣椒酱</a>
    All rights reserved
    <a style="color: #ff8a00" href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">冀ICP备19018276号</a>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>


#app-footer {
  height: 50px;
  text-align: center;
  font-size: 14px;
  line-height: 50px;
  background: rgba(20, 20, 20, 0.7);
  color: rgba(255, 255, 255, 0.4);
  z-index: 100;
}

</style>